<template>
  <div class="abnormal-order">
    <div class="search">
      <el-form ref="searchForm" :model="searchForm" label-width="80px">
        <div class="row">
          <el-form-item label="仓库：" prop="warehouseId" class="customer-form">
            <el-select 
              class="white"
              clearable
              v-model="searchForm.warehouseId"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货主：" prop="customerId">
            <el-select 
              class="white"
              clearable
              v-model="searchForm.customerId"
              placeholder="请选择货主"
              @change="changeCustomerList"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="项目名称："
            prop="projectId"
          >
            <el-select
              class="gray white"
              v-model="searchForm.projectId"
              placeholder="请选择项目"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="日期：" prop="date" class="customer-form">
            <el-date-picker
              v-model="searchForm.date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button class="btn-blue" @click="search">搜索</el-button>
            <el-button class="btn-white" @click="resetForm('searchForm')">清空</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="operation-btn">
        <el-button
          class="btn-white entry"
          icon="el-icon-download"
          @click="openEntry"
          >录入</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="tableData" style="width: 100%">
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        ></el-table-column>
        <el-table-column
          label="操作"
          width="150"
        >
          <template slot-scope="scope">
            <el-button class="btn-text" type="text" @click="lookDetails(scope.row.id)">详情</el-button>
            <el-button v-if="scope.row.validStatus" class="btn-text" type="text" @click="mod(scope.row.id)">编辑</el-button>
            <el-button v-if="scope.row.validStatus" class="btn-text btn-red" type="text" @click="nullify(scope.row.id)">作废</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>


    
    <!-- 录入 -->
    <el-dialog
      :title="title"
      top="12vh"
      :visible.sync="dialog"
      width="600px"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      class="entry-dialog"
    >
      <el-form class="entry-form" ref="entryForm" :model="entryForm" :rules="rules">
        <div class="row">
          <el-form-item label="仓库" prop="warehouseId" class="left">
            <el-select 
              class="white"
              clearable
              :disabled="type === 'details'"
              v-model="entryForm.warehouseId"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货主：" prop="customerId">
            <el-select 
              class="white"
              clearable
              :disabled="type === 'details'"
              v-model="entryForm.customerId"
              placeholder="请选择货主"
              @change="changeEntryFormCustomerList"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="日期" prop="date" class="left">
            <el-date-picker
              v-model="entryForm.date"
              type="date"
              :disabled="type === 'details'"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="项目名称："
            prop="projectId"
          >
            <el-select
              class="gray white"
              v-model="entryForm.projectId"
              placeholder="请选择项目"
              :disabled="type === 'details'"
            >
              <el-option
                v-for="item in entryFormProjectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="快递名称" prop="expressId" class="left">
            <el-select
              class="gray white"
              v-model="entryForm.expressId"
              :disabled="type === 'details'"
              clearable
              placeholder="请选择快递名称"
            >
              <el-option
                v-for="item in logisticsList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号：" prop="expressCode">
            <el-input
              class="gray white"
              v-model="entryForm.expressCode"
              placeholder="请输入"
              :disabled="type === 'details'"
              clearable
            ></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="出库时间" prop="deliveryTime" class="left">
            <el-date-picker
              v-model="entryForm.deliveryTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :disabled="type === 'details'"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="异常类型："
            prop="type"
          >
            <el-select
              class="gray white"
              v-model="entryForm.type"
              placeholder="请选择项目"
              :disabled="type === 'details'"
            >
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="问题描述" prop="problemDescription" class="left">
            <el-input
              type="textarea"
              resize="none"
              class="white"
              v-model="entryForm.problemDescription"
              placeholder="请输入"
              :disabled="type === 'details'"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="处理结果" prop="processingResults">
            <el-input
              type="textarea"
              resize="none"
              class="white"
              v-model="entryForm.processingResults"
              placeholder="请输入"
              :disabled="type === 'details'"
              clearable
            ></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="备注" prop="remarks" class="left">
            <el-input
              type="textarea"
              resize="none"
              class="white"
              v-model="entryForm.remarks"
              placeholder="请输入"
              :disabled="type === 'details'"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="上传照片(最多上传9张)" prop="images" class="images" :class="type === 'details'?'disabled-img':''">
            <el-upload
              ref="upload"
              action="#"
              :class="entryForm.images.length < 9 ?'':'none'"
              list-type="picture-card"
              :limit="9"
              :on-exceed="handleLimit"
              :on-remove="onRemove"
              :before-upload="beforeUpload"
              :auto-upload="true"
              :file-list="fileList"
              :disabled="type === 'details'"
            >
              <el-button
                v-loading="loading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                slot="trigger"
                size="small"
                type="primary"
              >
                <i class="el-icon-plus add"></i>
              </el-button>
            </el-upload>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="confirm('entryForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import Expenses from "models/expenses";
const expenses = new Expenses();
import Logistics from "models/logistics";
const logistics = new Logistics();
import ImgUploader from "common/js/img-upload.js";
const imgUploader = new ImgUploader();
import ChargeRegister from "models/charge-register";
import AbnormalOrder from "models/data-entry/abnormal";
export default {
  components: {
    PaginationTpl
  },

  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '日期', prop: 'createTime', width: '150'},
        {label: '仓库', prop: 'warehouseName', width: ''},
        {label: '客户', prop: 'customerName', width: ''},
        {label: '项目', prop: 'projectName', width: ''},
        {label: '快递名称', prop: 'expressName', width: ''},
        {label: '快递单号', prop: 'expressCode', width: '120'},
        {label: '出库时间', prop: 'deliveryTime', width: '150'},
        {label: '异常类型', prop: 'typeVal', width: ''},
      ],
      typeObj: {
        1: '快递停滞',
        2: '仓库错发',
        3: '快递异常,包装破损',
        4: '客户收货少件',
        5: '快递丢件',
        6: '客退件签收问题',
        7: '拦截',
        8: '仓库少发货物',
        9: '催派送',
        10: '异常签收',
        11: '改地址',
        12: '异常退回'
      },
      typeList: [
        // {id:1, name: '快递停滞'},
        {id:2, name: '仓库错发'},
        {id:3, name: '快递异常,包装破损'},
        // {id:4, name: '客户收货少件'},
        // {id:5, name: '快递丢件'},
        // {id:6, name: '客退件签收问题'},
        // {id:7, name: '拦截'},
        {id:8, name: '仓库少发货物'},
        // {id:9, name: '催派送'},
        // {id:10, name: '异常签收'},
        // {id:11, name: '改地址'},
        // {id:12, name: '异常退回'}
      ],
      warehouseList: [],
      customerList: [],
      projectList: [],
      searchForm: {
        warehouseId: '',
        customerId: '',
        projectId: '',
        date: ''
      },

      title: '录入',
      type: 'entry',
      dialog: false,
      entryFormProjectList: [],
      fileList: [],
      loading: false,
      id: null,
      entryForm: {
        warehouseId: '',
        date: '',
        customerId: null,
        projectId: null,
        expressId: null,
        expressCode: null,
        deliveryTime: '',
        type: null,
        problemDescription: '',
        processingResults: '',
        remarks: '',
        images: []
      },
      rules: {
        warehouseId: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        customerId: [
          { required: true, message: '请选择货主', trigger: 'change' }
        ],
        projectId: [
          { required: true, message: '请选择项目', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        expressId: [
          { required: true, message: '请输入快递名称', trigger: 'blur' }
        ],
        expressCode: [
          { required: true, message: '请输入快递单号', trigger: 'blur' }
        ],
        deliveryTime: [
          { required: true, message: '请选择出库时间', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择异常类型', trigger: 'change' }
        ],
      },
      logisticsList: [],
    }
  },

  created() {
    this.initList()
    this.getLogisticsList()
    this.getWarehouseList()
    this.getCustomerList()
  },

  methods: {
    //获取仓库数据
    getWarehouseList() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },

    /* 获取快递类型 */
    getLogisticsList() {
      logistics.getExpressData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.logisticsList = arr;
        }
      });
    },

    /* 获取货主名称 */
    getCustomerList() {
      logistics.getCustomerData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.customerList = arr;
        }
      });
    },
    
    /* 获取项目名称 */
    initGetProjectList(type) {
      let customerId
      let warehouseId
      if (type === 'noEntry') {
        customerId = this.searchForm.customerId
        warehouseId = this.searchForm.warehouseId
      } else {
        customerId = this.entryForm.customerId
        warehouseId = this.entryForm.warehouseId
      }
      ChargeRegister.getProjectList(customerId, warehouseId).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.projectsName;
            arr.push(obj);
          });
          if (type === 'noEntry') {
            this.projectList = arr;
            this.searchForm.projectId = arr.length > 0 ? arr[0].id : '';
          } else {
            this.entryFormProjectList = arr;
            this.entryForm.projectId = arr.length > 0 ? arr[0].id : '';
          }
        }
      });
    },
    
    initList() {
      let pageNo = this.currentPage
      let warehouseId = this.searchForm.warehouseId
      let customerId = this.searchForm.customerId
      let projectId = this.searchForm.projectId
      let entryDate = this.searchForm.date
      let data = {
        pageNo,
        warehouseId,
        customerId,
        projectId,
        entryDate
      }
      AbnormalOrder.getAbnormalOrderList(data).then(res => {
        if (res.success) {
          let arr = []
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.createTime = i.entryDate
            obj.validStatus = i.validStatus
            obj.warehouseName = i.warehouseName
            obj.customerName = i.customerName
            obj.projectName = i.projectName
            obj.expressCode = i.expressNo
            obj.expressName = i.expressName
            obj.deliveryTime = i.outboundDate
            obj.type = i.questionType
            obj.typeVal = this.typeObj[i.questionType]
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /* 详情 */
    initAbnormalOrderDetails(id) {
      AbnormalOrder.postAbnormalOrderDetails(id).then(res => {
        if (res.success) {
          let { warehouseId, entryDate, customerId, projectId, expressId, expressNo,
          outboundDate, questionType, questionDesc, dealResult, remark, questionAppendixList} = res.result
          this.entryForm.warehouseId = warehouseId
          this.entryForm.date = entryDate
          this.entryForm.customerId = customerId
          this.entryForm.projectId = projectId
          this.entryForm.expressId = expressId
          this.entryForm.expressCode = expressNo
          this.entryForm.deliveryTime = outboundDate
          this.entryForm.type = questionType
          this.entryForm.problemDescription = questionDesc
          this.entryForm.processingResults = dealResult
          this.entryForm.remarks = remark
          this.entryForm.images = questionAppendixList
          let fileList = []
          questionAppendixList.map(i => {
            let obj = {}
            obj.url = i
            fileList.push(obj)
          })
          this.fileList = fileList
          this.initGetProjectList('entry')
          this.dialog = true
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    changeCustomerList() {
      this.initGetProjectList('noEntry')
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initList();
    },

    search() {
      this.currentPage = 1
      this.initList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    changeEntryFormCustomerList() {
      this.initGetProjectList('entry')
    },
    
    openEntry() {
      this.title = '录入'
      this.type = 'entry'
      this.dialog = true
    },

    lookDetails(id) {
      this.title = '详情'
      this.type = 'details'
      this.initAbnormalOrderDetails(id)
    },

    mod(id) {
      this.title = '编辑'
      this.type = 'mod'
      this.id = id
      this.initAbnormalOrderDetails(id)
    },

    nullify(id) {
      this.$confirm("作废后需重新录入，是否操作？", "作废", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let data = { id };
        AbnormalOrder.postNullify(data).then(res => {
          if (res.success) {
            this.initList()
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    closeDialog() {
      this.title = '录入'
      this.type = 'entry'
      this.id = null
      this.entryForm.warehouseId = ''
      this.entryForm.date = ''
      this.entryForm.customerId = null
      this.entryForm.projectId = null
      this.entryForm.expressId = null
      this.entryForm.expressCode = null
      this.entryForm.deliveryTime = ''
      this.entryForm.type = null
      this.entryForm.problemDescription = ''
      this.entryForm.processingResults = ''
      this.entryForm.remarks = ''
      this.entryForm.images = []
      this.fileList = []
      this.loading = false,
      this.dialog = false
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.entryForm.warehouseId
          let entryDate = this.entryForm.date
          let customerId = this.entryForm.customerId
          let projectId = this.entryForm.projectId
          let expressId = this.entryForm.expressId
          let expressNo = this.entryForm.expressCode
          let outboundDate = this.entryForm.deliveryTime
          let questionType = this.entryForm.type
          let questionDesc = this.entryForm.problemDescription
          let dealResult = this.entryForm.processingResults
          let remark = this.entryForm.remarks
          let questionAppendixList = this.entryForm.images
          let data = {
            warehouseId,
            entryDate,
            customerId,
            projectId,
            expressId,
            expressNo,
            outboundDate,
            questionType,
            questionDesc,
            dealResult,
            remark,
            questionAppendixList
          }

          if (this.type === 'mod') data.id = this.id
          AbnormalOrder.postAbnormalOrderEntry(data).then(res => {
            if (res.success) {
              this.initList()
              this.closeDialog()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },


    
    /* ------------------------------ 以下是上传图片方法 --------------------------- */
    // 图片数量大于3
    handleLimit() {
      this.$message({
        message: "图片数量最多9张",
        type: "warning",
      });
    },

    // 删除图片
    onRemove(file, fileList) {
      this.fileList = fileList;
      this.entryForm.images = [];
      this.fileList.map(value => {
        this.entryForm.images.push(value.url);
      });
    },

    // 上传图片进行判断图片
    beforeUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt1M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
        return false;
      } else {
        this.loading = true;
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then((res) => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              this.fileList.push(obj);
              this.loading = false;
              this.entryForm.images = [];
              this.fileList.map(value => {
                this.entryForm.images.push(value.url);
              });
            } else {
              this.loading = false;
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.loading = false;
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
      }
    },
  }
}
</script>

<style lang='scss'>
.abnormal-order {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  .search {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    .entry {
      padding: 0px 14px;
    }
    .el-form {
      min-height: 72px;
      .el-form-item {
        .el-date-editor {
          width: 192px;
        }
      }
      .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .customer-form {
        .el-form-item__label {
          width: 50px!important;
        }
        .el-form-item__content {
          margin-left: 50px!important;
        }
      }
    }
    .operation-btn {
      padding-top: 48px;
    }
  }
  
  .table {
    padding: 16px;
    .btn-red {
      color: #F55545;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }

  
  .entry-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 16px;
    }
    .entry-form {
      .row {
        display: flex;
        justify-content: flex-start;
        .el-form-item {
          width: 50%;
        }
        .left {
          margin-right: 30px;
        }
      }
      .el-form-item {
        .el-form-item__label {
          width: 100%;
          text-align: left;
        }
        .el-form-item__content,
        .el-select,
        .el-date-editor {
          width: 100%;
        }
        .el-textarea {
          height: 64px;
          .el-textarea__inner {
            min-height: 64px!important;
          }
        }
        .el-date-editor.is-disabled .el-input__inner,
        .el-textarea.is-disabled .el-textarea__inner,
        .el-input.white .el-input__inner {
          background: white;
          color: #606266;
        }

      }
      
      .images {
        width: 100%;
        height: auto;
        margin-bottom: 0;
        .el-form-item__content {
          height: auto;
          .el-upload-list {
            .el-upload-list__item {
              width: 32px;
              height: 32px;
              margin-top: 0px;
            }
          }
          .el-upload--picture-card {
            width: 32px;
            height: 32px;
            border: 0px;
            line-height: 0px;
            .el-upload-list__item-thumbnail {
              height: 32px;
            }
          }
          .authorize {
            .el-upload-list__item-delete {
              display: none;
            }
          }
          .none {
            .el-upload--picture-card {
              display: none;
            }
          }
          .el-loading-spinner {
            top: 28px;
          }
          .el-upload--picture-card i {
            font-size: 18px;
          }
          .el-upload-list--picture-card .el-upload-list__item-status-label{
            right: -18px;
            top: -15px;
          }
          .el-upload-list--picture-card .el-upload-list__item-status-label i {
            width: 13px;
            height: 8px;
            margin-top: 14px;
            font-size: 1px;
          }
          .el-upload-list--picture-card .el-upload-list__item-actions .el-upload-list__item-delete {
            position: absolute;
            top: 3px;
            right: 8px;
            font-size: 14px;
          }
          .el-button {
            width: 32px;
            height: 32px;
            background: #fff;
            border-radius: 2px;
            border: 1px solid#eee;
                font-size: 14px;
            > span {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              .add {
                color: #eee;
                font-size: 14px;
              }
            }
          }
        }
      }
      .disabled-img {
        .el-upload,
        .el-form-item__content .el-button {
          cursor: not-allowed;
        }
      }
    }
    .el-dialog__footer {
      padding: 0px;
      .dialog-footer {
        border-top: 1px solid #eee;
        padding-top: 16px;
        padding-bottom: 16px;
        display: flex;
        justify-content: center;
      }
    }
  }

}
</style>
